{
  "menu": {
    "login": "Logga in",
    "logout": "Logga ut",
    "support": "Support"
  },
  "applicationSummary": {
    "companyNameLabel": "Företag",
    "change": "Byt ansökan"
  },
  "applicationSelector": {
    "choose": "Välj",
    "cancel": "Avbryt"
  },
  "login": {
    "identificationSuccessful": "Du har blivit identifierad"
  },
  "eligibilityCheckForm": {
    "heading": "Se företagets lånemöjligheter",
    "checkYourEligibility": "Se lånemöjligheter",
    "checkYourEligibilityWithoutCreditCheck": "Se lånemöjligheter - utan UC"
  },
  "preliminaryBidForm": {
    "preliminaryBidHeading": "Se företagets låneutrymme",
    "estimateLimitWithoutCreditCheck": "Se låneutrymme - utan UC",
    "estimateLimit": "Uppskatta ditt låneutrymme",
    "loadingText": "Beräknar hur mycket du kan få i lån...",
    "loadingTextEligibilityCheck": "Beräknar dina lånemöjligheter...",
    "weEstimateThatCompanyCanReceive": "Vi uppskattar att {{organisationName}} får låna ca ",
    "immediateResponse": "Svar direkt",
    "immediateResponseWithoutCreditCheck": "Svar direkt, utan kreditupplysning"
  },
  "delegatedInformationPage": {
    "heading": "Du har blivit inbjuden att lägga till information",
    "description": "har bett dig lägga till information i samband med en ansökan om finansiering för företaget"
  }
}
